import { getLangType } from '@/utils/tools.js'
import { kEnglishEnabled } from '@/i18n/tools.js'

let language = 'zhCn'

if (getLangType() == 'zhTc') {
    language = 'zh-hk'
} else if (kEnglishEnabled && getLangType() == 'enUs') {
    language = 'en'
} else {
    language = 'zhCn'
}

export const tencentCaptchaService = callback =>
    new window.TencentCaptcha(
        '2013119836',
        res => {
            if (callback) {
                callback(res)
            }
        },
        {
            // enableDarkMode: localStorage.getItem('theme') == 'dark' ? 'force' : false,
            needFeedBack: false,
            userLanguage: language, // 配置验证码的语言
        }
    )
